module.exports = __webpack_public_path__ + "img/coupon.826ab809.svg";